import styled, { createGlobalStyle } from "styled-components/macro";
import "./designTokens.scss";

export const GlobalStyles = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;  
    margin: 0;
    padding: 0;
    font-family: 'DM Sans', sans-serif;
  }

  body,
  h1, h2, h3, h4, h5, h6,
  p, ul, ol, li {
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
  }

  ul, ol {
    list-style: none;
  }
  
  img {
    display: block;
  }

  input:-internal-autofill-selected {
    background-color: transparent !important;
  }

  input::-webkit-search-cancel-button,
  input::-webkit-search-decoration,
  input::-webkit-search-results-button,
  input::-webkit-search-results-decoration {
    display: none;
  }

  input::-ms-clear,
  input::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }

  .centered-modal {
  .modal-dialog {
    display: flex;
    align-items: center;
    min-height: 100vh;
    justify-content: center;background: rgba(0, 0, 0, 0.45);
    z-index: 9999;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  .close-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 16px;

    &:hover {
      background-color: var(--Neutral-8);
    }
 }

.modal-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

  .modal-content {
    border-radius: 16px;
    background: #fff;
    display: flex;
    max-width: 480px;
    width: 100%;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    position: relative;

  }
}


  /* Sidebar modal — only position when visible */
  .sidebar-modal {
    overflow: hidden;
    outline: 0;

    &.show {
      position: fixed;
      top: 0;
      right: 0;
      z-index: 1050;

      .modal-dialog {
        position: fixed;
        right: 16px;
        top: 16px;
        bottom: 16px;
        margin: 0;
        transform: none;
        max-width: 400px;
        width: 100%;
        background-color: #fff;
        border-radius: 16px;

        .modal-content {
          .sidebar-close-icon {
            display: flex;
            cursor: pointer;
            width: 24px;
            height: 24px;
          }

          
          .modal-header{
            border-bottom: 1px solid var(--Neutral-8);
            height: 72px;
          }

          .modal-body {
            .loading-state {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 12px;
              gap: 8px;

              span {
                color: var(--SINGAL-Neutral-100);
                font-size: 16px;
                font-weight: 600;
                line-height: 24px;
              }
            }
          }
        }
      }
    }
  }

  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #353c59;

    &.show {
      opacity: 0.5;
    }
  }
`;

export const CommonDashboardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 0 16px 0;

  .common-dashboard-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .common-heading {
    color: var(--Neutral-100);
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: -0.048px;
    padding: 4px;
  }

  &.common-dashboard-talent-agency-wrapper {
    padding: 0 0 24px 0;
  }
`;

export const ValidationWrapperStyles = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;

  &.err-msg {
    align-items: center;
  }

  button {
    border-radius: 12px;
  }
`;
